<template>
  <div>
    <!-- buttons for smaller screens -->
    <div
      v-if="!timer.widget.archived"
      class="dashboard__button-wrap dashboard__button-wrap--mobile layout--margin-top-sm"
      :class="{
        'dashboard__button-wrap--end': !timer.ended,
        'dashboard__button-wrap--list-view': listView,
        'dashboard__button-wrap--wide': wide,
      }"
    >
      <span
        v-if="timer.ended"
        class="button button--narrow dashboard__status layout--margin-right-xs"
        :class="{ 'layout--hide-tablet-landscape-up-flex': listView }"
        ><strong>ENDED</strong></span
      >
      <button
        v-if="listView"
        type="button"
        class="button button--secondary button--small layout--hide-desktop-down layout--margin-right-xs"
        @click="openTimerCodeModal"
      >
        Code
      </button>
      <button
        type="button"
        class="button button--secondary button--narrow button--dropdown"
        @click="toggleMenu"
      >
        Actions
        <font-awesome-icon icon="chevron-down" class="button__icon-right" />
      </button>
      <ul role="menu" class="dashboard__button-menu-wrap" v-if="menuOpen">
        <li
          class="dashboard__button-menu-item"
          :class="{ 'layout--hide-desktop-up': listView }"
        >
          <button
            type="button"
            class="button button--secondary button--small button--menu-item layout--text-left"
            @click="openTimerCodeModal"
          >
            Code
          </button>
        </li>
        <li class="dashboard__button-menu-item">
          <router-link
            :to="{
              name: 'edit timer',
              query: { timerId: timer.widget.id },
            }"
            class="button button--secondary button--small button--menu-item layout--text-left"
          >
            Edit
          </router-link>
        </li>
        <li class="dashboard__button-menu-item">
          <button
            type="button"
            class="button button--secondary button--small button--menu-item layout--text-left"
            @click="duplicateTimer"
          >
            Duplicate
          </button>
        </li>
        <li class="dashboard__button-menu-item">
          <button
            type="button"
            class="button button--secondary button--small button--menu-item layout--text-left"
            @click="openArchiveModal"
          >
            Archive
          </button>
        </li>
      </ul>
    </div>
    <!-- buttons for larger screens -->
    <div
      v-if="!timer.widget.archived && !listView"
      class="dashboard__button-wrap layout--margin-top-sm"
    >
      <div class="layout--flex-start">
        <button
          type="button"
          class="button button--secondary"
          :class="{
            'layout--margin-left-xs': wide,
            'button--small': !wide,
            'button--narrow': !wide,
          }"
          @click="openTimerCodeModal"
        >
          Code
        </button>
        <router-link
          :to="{
            name: 'edit timer',
            query: { timerId: timer.widget.id },
          }"
          class="button button--secondary"
          :class="{
            'layout--margin-left-xs': wide,
            'button--small': !wide,
            'button--narrow': !wide,
          }"
        >
          Edit
        </router-link>
        <button
          type="button"
          class="button button--secondary"
          :class="{
            'layout--margin-left-xs': wide,
            'button--small': !wide,
            'button--narrow': !wide,
          }"
          @click="duplicateTimer"
        >
          Duplicate
        </button>
      </div>
      <button
        type="button"
        class="button button--secondary"
        :class="{
          'layout--margin-left-xs': wide,
          'button--small': !wide,
          'button--round': !wide,
          'button--narrow': !wide,
        }"
        @click="openArchiveModal"
      >
        <IconArchive class="icon" v-if="!wide" /><span
          :class="{ 'sr-only': !wide }"
          >Archive</span
        >
      </button>
    </div>
    <!-- button for archived items -->
    <div
      v-if="timer.widget.archived"
      class="dashboard__button-wrap dashboard__button-wrap--archive layout--margin-top-sm"
    >
      <LoadingButton
        secondary
        small
        wide
        :loading="restoring"
        :event="restoreTimer"
        label="Unarchive"
        loadingLabel="Restoring..."
      />
    </div>
  </div>
</template>

<script>
import { mapWaitingActions } from "vue-wait";

import TimerCode from "./TimerCode";
import ArchiveModal from "./ArchiveModal.vue";
import LoadingButton from "./LoadingButton";

import IconArchive from "../assets/icons/iconArchiveTimer.svg";
import { mapGetters } from "vuex";

export default {
  name: "timer-controls",
  props: {
    timer: Object,
    listView: Boolean,
    wide: Boolean,
  },
  components: {
    IconArchive,
    TimerCode,
    LoadingButton,
  },
  data() {
    return {
      menuOpen: false,
      archiving: false,
      restoring: false,
      duplicating: false,
    };
  },
  computed: {
    ...mapGetters("account", ["hideArchiveModal"]),
  },
  methods: {
    ...mapWaitingActions("timers", {
      updateTimer: "updating timer",
      createTimer: "duplicating timer",
    }),
    archiveTimer: function() {
      const newTimer = JSON.parse(JSON.stringify(this.timer));
      newTimer.widget.archived = true;
      newTimer.widget.active = false;
      this.updateTimer(newTimer.widget);
    },
    restoreTimer: function() {
      this.restoring = true;
      const newTimer = JSON.parse(JSON.stringify(this.timer));
      newTimer.widget.archived = false;
      newTimer.widget.active = true;
      this.updateTimer(newTimer.widget).then(() => (this.restoring = false));
    },
    openTimerCodeModal: function() {
      this.menuOpen = false;
      this.$modal.show(TimerCode, { code: this.timer.apiUrl, modal: true });
    },
    openArchiveModal: function() {
      this.menuOpen = false;
      if (this.hideArchiveModal) {
        this.archiveTimer();
        return;
      }
      this.$modal.show(ArchiveModal, { timer: this.timer });
    },
    duplicateTimer: function() {
      this.menuOpen = false;
      const newWidget = JSON.parse(JSON.stringify(this.timer.widget));
      newWidget.name = newWidget.name += " Copy";
      this.createTimer(newWidget).then(result =>
        this.$router.push({
          name: "edit timer",
          query: { timerId: result.widget.id },
        })
      );
    },
    toggleMenu: function() {
      this.menuOpen = !this.menuOpen;
    },
  },
};
</script>

<style></style>
